import React, { forwardRef, useImperativeHandle } from 'react';
import PropTypes from 'prop-types';
import { SelectField, validations } from '@unite-us/app-components';

const SelectFieldWrapper = forwardRef((props, ref) => {
  const { shouldValidate, ...otherProps } = props;

  useImperativeHandle(ref, () => ({
    props: {
      field: otherProps.field,
      validations: shouldValidate ? validations.isRequired : null,
    },
  }), [shouldValidate, otherProps.field]);

  return (
    <SelectField
      {...otherProps}
      validations={shouldValidate ? validations.isRequired : null}
      ref={null}
    />
  );
});

SelectFieldWrapper.displayName = 'SelectFieldWrapper';

SelectFieldWrapper.propTypes = {
  shouldValidate: PropTypes.bool.isRequired,
};

export default SelectFieldWrapper;
